export const emailSettings = {
  emailTemplates: "E-Mail-Vorlagen",
  mailer: "Mailer",
  automaticNotifications: "Automatische Benachrichtigungen"
};
